"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  alert: {
    close: 'Close'
  },
  calendar: {
    nextMonth: 'Next month',
    previousMonth: 'Previous month',
    nextYear: 'Next year',
    previousYear: 'Previous year'
  },
  formControl: {
    required: 'Required field'
  },
  modal: {
    close: 'Close'
  },
  paginator: {
    of: 'of',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    currentPage: 'Current page'
  },
  select: {
    removeItem: 'Remove'
  }
};
exports.default = locale;